(function() {
  'use strict';

  angular
    .module('admin.home.service', [])
    .factory('HomeAdminService', HomeAdminService);

  /** @ngInject */
  function HomeAdminService($http, $q, API) {

    function get(id){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/users/' + id)
            .success(defer.resolve);

        return defer.promise;
    }

    function pushNotificationOneSignal() {
      var defer = $q.defer();

      $http.post(API.API_URL + 'admin/push_notifications/onesignal?start=0&limit=2000', { "en": "[EN]: Test QP2" })
          .success(defer.resolve);

      return defer.promise;
    }

    return{
        get: get,
        pushNotificationOneSignal: pushNotificationOneSignal
    };

  }

})();
